/* =============================================================
   PRx Secondary Nav — mobile hide-on-scroll-down / show-on-scroll-up
   Mirrors the vendor header's "on-scroll-up" sticky behavior
   (StickyHeader in theme.js) for the black secondary nav bar.

   Only toggles classes + one CSS variable. All visual behavior lives
   in prx-secondary-nav.css, scoped to max-width: 1023px, so desktop
   is unaffected.
   ============================================================= */
(() => {
  const HIDDEN_CLASS = 'prx-nav-hidden';
  const TOLERANCE = 5; // px of scroll movement ignored, prevents flicker

  let lastScrollY = window.scrollY;
  let ticking = false;

  // Query each time (cheap) so it keeps working after the theme editor
  // re-renders the section.
  const getSection = () => document.querySelector('.prx-secondary-nav-section');

  const update = () => {
    ticking = false;

    const section = getSection();
    if (!section) return;

    const scrollY = window.scrollY;
    const delta = scrollY - lastScrollY;
    const threshold = section.offsetHeight + 100;

    if (scrollY <= threshold) {
      // Near the top: bar is in normal page flow, always visible
      section.classList.remove(HIDDEN_CLASS);
    } else if (delta > TOLERANCE) {
      section.classList.add(HIDDEN_CLASS);
    } else if (delta < -TOLERANCE) {
      section.classList.remove(HIDDEN_CLASS);
    } else {
      return; // movement within tolerance: keep state, keep lastScrollY
    }

    lastScrollY = scrollY;

    // Lets other sticky elements (scroll-spy nav, comparison table header)
    // sit below the bar while it's showing
    const offset = section.classList.contains(HIDDEN_CLASS) ? 0 : section.offsetHeight;
    document.documentElement.style.setProperty('--prx-mobile-nav-offset', offset + 'px');
  };

  // ADA (Allyant #1): this section's wrapper is the page's <header> (banner
  // landmark, via the section schema "tag": "header"), since the logo, search,
  // account and cart live here. The vendor header (sections/header.liquid)
  // still renders its own <header> for the desktop mega menu; demote it so the
  // page has a single banner. Its <nav> keeps its own navigation landmark.
  // Done here instead of editing the vendor file.
  const demoteVendorHeader = () => {
    document.querySelectorAll('.header-section header.header').forEach((h) => h.setAttribute('role', 'none'));
  };
  demoteVendorHeader();
  document.addEventListener('shopify:section:load', demoteVendorHeader);

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  update();
})();
